/**
 * i18n bootstrap for the user app.
 *
 * Scope (proof-of-concept): Settings page strings only — see
 * `src/locales/{en,hi}/settings.json`. The rest of the app is untranslated
 * English; adding more namespaces is purely additive (drop JSON files in
 * the same folder, list them in the `ns` array below, and import the
 * namespace inside the component).
 *
 * Language is owned by `PreferencesProvider` (theme/density/language live
 * together). This file just initialises i18next with the loaded language
 * so the first render isn't a flash of the wrong locale.
 */
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import enSettings from './infrastructure/locales/en/settings.json'
import hiSettings from './infrastructure/locales/hi/settings.json'
import { loadPreferences } from './modules/preferences/preferences'

void i18n.use(initReactI18next).init({
  resources: {
    en: { settings: enSettings },
    hi: { settings: hiSettings },
  },
  lng: loadPreferences().language,
  fallbackLng: 'en',
  ns: ['settings'],
  defaultNS: 'settings',
  interpolation: { escapeValue: false }, // React already escapes
  returnNull: false,
})

export default i18n
